import axios from 'axios';
import apiConfig from '../api.config';

export default function updateGuestlinkSmtpAuthConfig({ hotelId, smtpAuthConfig, applyToAllHotels }) {
  const {
    host,
    URIs: { updateGuestlinkSmtpAuthConfig },
  } = apiConfig;

  const uri = `${host}${updateGuestlinkSmtpAuthConfig.replace(':hotelId', hotelId)}?applyToAllHotels=${applyToAllHotels}`;

  return axios
    .put(uri, JSON.stringify({ smtpAuthConfig }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
